function toggleFAQ(btn){
  var item = btn.parentElement;
  var isOpen = item.classList.contains('open');

  document.querySelectorAll('.faq-item.open').forEach(function(i){
    i.classList.remove('open');
  });

  if(!isOpen){
    item.classList.add('open');
  }
}

function showDay(id, btn){
  document.querySelectorAll('.day-content').forEach(function(c){
    c.classList.remove('active');
  });

  document.querySelectorAll('.day-tab').forEach(function(t){
    t.classList.remove('active');
  });

  var day = document.getElementById('day-' + id);
  if(day){
    day.classList.add('active');
  }

  if(btn){
    btn.classList.add('active');
  }
}

document.addEventListener('DOMContentLoaded', function(){

  document.querySelectorAll('.reveal').forEach(function(el){
    el.classList.add('visible');
  });

  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var target = document.querySelector(this.getAttribute('href'));
      if(target){
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  var bookSection = document.getElementById('book');
  var stickyCTA = document.getElementById('sticky-cta');

  if(bookSection && stickyCTA && 'IntersectionObserver' in window){
    var bookObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        stickyCTA.style.opacity = e.isIntersecting ? '0' : '1';
        stickyCTA.style.pointerEvents = e.isIntersecting ? 'none' : 'all';
      });
    }, { threshold: 0.2 });

    bookObs.observe(bookSection);
  }

});